export default [
  {
    name: 'LeadsReceptionsSingleLayout',
    path: 'leads-receptions',
    component: () => import('pages/leads-receptions/_layouts/LeadsReceptionsSingleLayout.vue'),
    /**
     * Devido sempre existir a tab de leads, independentemente da permissão (a permissão fica no menu), caso tente
     * entrar no layout, ele vai redirecionar para a tab de leads por padrão.
     */
    redirect: { name: 'LeadsReceptionsLeadsList' },
    children: [
      {
        name: 'LeadsReceptionsLeadsList',
        path: 'leads',
        meta: { slug: 'leads' },
        component: () => import('pages/leads-receptions/tabs/leads/LeadsReceptionsLeadsList.vue')
      },
      {
        name: 'LeadsReceptionsWaitingList',
        path: 'waiting',
        meta: { slug: 'waiting' },
        component: () => import('pages/leads-receptions/tabs/LeadsReceptionsWaitingList.vue')
      },
      {
        name: 'LeadsReceptionsRoulettesList',
        path: 'roulettes',
        meta: { slug: 'roulettes' },
        component: () => import('pages/leads-receptions/tabs/roulettes/LeadsReceptionsRoulettesList.vue')
      },
      {
        name: 'LeadsReceptionsHistoryList',
        path: 'history',
        meta: { slug: 'history' },
        component: () => import('pages/leads-receptions/tabs/LeadsReceptionsHistoryList.vue')
      },
      {
        name: 'LeadsReceptionsDashboard',
        path: 'dashboard',
        meta: { slug: 'dashboard' },
        component: () => import('pages/leads-receptions/tabs/dashboard/LeadsReceptionsDashboard.vue')
      }
    ]
  },
  {
    name: 'LeadsReceptionsLeadsCreate',
    path: 'leads-receptions/leads/new',
    component: () => import('pages/leads-receptions/leads-create/LeadsReceptionsLeadsCreate.vue')
  },
  {
    name: 'LeadsReceptionsRoulettesCreate',
    path: 'leads-receptions/roulettes/new',
    component: () => import('pages/leads-receptions/tabs/roulettes/form/LeadsReceptionsRoulettesForm.vue')
  },
  {
    name: 'LeadsReceptionsRoulettesEdit',
    path: 'leads-receptions/roulettes/:id/edit',
    component: () => import('pages/leads-receptions/tabs/roulettes/form/LeadsReceptionsRoulettesForm.vue')
  }
]
